<template>
<div>
	<div class="am-post"
		:class="{ 'is-idle': !init || !loaded }"
	>

		<div class="am-post__container">
			<div class="am-post__wrapper">
				<header class="am-post__header">
					<p class="text-uppercase am-post__listtitle__header">{{ cat.name }}</p>
					<h1 class="am-post__title">
						{{ title }}
					</h1>
				</header>

				<am-text class="am-post__text" v-html="text" type="body">
				</am-text>

			</div>
			<div style=" background-size: cover; background-position: center;" class="am-post__image" :data-src="image"></div>
			<!-- <router-link class="am-post__img-btn" to="/blog"> -->
			<!-- 	<div class="am-post__image_bottom" :data-src="posts[1].image"> <p class="am-post__img-btn-text">{{ posts[1].title }}</p> </div> -->
			<!-- </router-link> -->
		</div>


	</div>
	<div class="am-post__list">

		<div class="am-post__background text-center" :data-src="background">
			<h1>Ultimos posts</h1>
		</div>

		<div  class="row m-0">
			<div v-for="(post, index) in morePosts" v-bind:key="post.id" v-bind:index="index" class="col-md-6 p-0">
				<!-- <router-link class="am-post__img-btn" :to="{path: post.slug}">
					<div class="am-post__first" :data-src="post.img"> <p class="am-post__img-btn-text">{{ post.title }}</p> </div>
				</router-link> -->
				<router-link  class="am-post__img-btn" :to="{path:  '/post/' + post.slug}" > <!-- :to="{path: post.slug}" --> <!-- :href="$router.resolve({slug: 'teste/' + post.slug}).href" -->
					<div @click="refresh" class="am-post__first post-mobile-height" :data-src="post.img"> 
						<p class="am-post__img-btn-text"> <span class="text-uppercase">{{ post.category.name }}</span><br>{{ post.title }}</p> 
					</div>
				</router-link>
			</div>
		</div>

	</div>
</div>

</template>
A
<script>
import AMText from '@/components/atoms/AMText'
import { TweenMax, Power2 } from 'gsap/TweenMax'

export default {
	components: {
		'am-text': AMText,
	},

	props: {
		init: {
			type: Boolean,
			default: true
		},
		title: {
			type: String,
			default: 'Adipisicing quo delectus deleniti aut quis, quasi totam? Vero adipisci nostrum itaque ducimus culpa?'
		},
		cat: {
			type: Object,
			default: {
				id:	'1',
				name:	"Cimento branco",
				created_at:	"2020-04-01 21:01:22",
				updated_at:	"2020-04-01 21:01:22"
			}
		},
		category_id: {
			type: String,
			default: '-1'
		},
		slug: {
			type: String,
			default: 'my_slug'
		},
		text:{
			type: String,
			default: "A influência da Arquitetura Moderna se estende a diversas áreas, incluindo a arte e o design, e perdura até hoje em cidades do mundo inteiro. Assimilar o seu conceito é importante para compreender diversas características arquitetônicas, sejam elas contemporâneas, de décadas passadas e, possivelmente, até futuras. Neste post, você vai descobrir aspectos relevantes da Arquitetura Moderna e conhecer alguns dos principais nomes influenciados por essa vertente que mudou a forma com que as construções integram os ambientes. Confira! Qual é a diferença entre Moderno e Contemporâneo? No dia a dia, é comum confundir o significado de “moderno” e “contemporâneo”. Provavelmente você já viu esse primeiro termo sendo usado para se referir a algo atual. Está incorreto? Sim e não! Vamos explicar. O engano acontece porque há uma associação da palavra “moderno” com tudo aquilo que é novo ou diferente. No entanto, oficialmente, “moderno” remete aos ideais que surgiram na Europa e se alastraram pelo mundo no período entre 1453, com a tomada de Constantinopla pelos turcos otomanos, até 1789, com o início da Revolução Francesa. Já o período que sucede à Revolução Francesa, ou seja, dos anos 1789 até os dias atuais, é conhecido por Idade Contemporânea. Então por que não é equivocado se referir a algo recente como “moderno”? Porque as influências do modernismo continuam muito fortes e se desdobram até hoje em muitos aspectos da nossa vida. Além disso, abrange todas as áreas do conhecimento humano: as artes, a ciência e até o modo como a História é interpretada."
		},
		background: {
			type: String,
			default: 'https://placeimg.com/640/480/nature/grayscale'
		},
		image: {
			type: String,
			default: 'https://placeimg.com/640/480/nature'
		},
		posts: {
			type: Array,
			default: [
				{
					id: 1, 
					title: "Entenda o que é a Arquitetura Moderna e quais são suas influências 1", 
					slug: "slug",
					category: "category",
					img: require('@/assets/images/hero/image.jpg'),
					text: "text",
					created_at: "created_at"
				},
			],
		},
	},
	
	data: () => ({
		loaded: false
	}),
	computed: {
		morePosts: function () {
			var more_posts = [];
			this.posts.forEach(e => {
				if(e.slug != this.slug && e.category_id == this.category_id){
					more_posts.push(e)
				}
			});
			this.posts.forEach(e => {
				if(e.slug != this.slug && e.category_id != this.category_id){
					more_posts.push(e)
				}
			});

			return more_posts.slice(0, 4);
		}
	},
	watch: {
		init(value) {
			if (value)
				this.onLoad()
		}
	},

	mounted() {
		if (this.init)
			this.onLoad()
	},

	methods: {
		refresh: function () {
			console.log("method called");
			console.log(window.scrollTo(0,0));
			/* this.$router.go(0) */
			
			window.scrollTo(0,0);
		},
		start() {
			// Background
			TweenMax.staggerFrom(this.$el.querySelectorAll('.am-post__background'), 1.5, {
				y: '-200px',
				opacity: 0,
				ease: Power2.easeOutl
			})

			// Gallery
			TweenMax.staggerFrom(this.$el.querySelectorAll('.am-post__image, .am-post__listimg, .am-post__image_bottom, .am-post__first'), 2, {
				x: '30%',
				opacity: 0,
				ease: Power2.easeOut
			})

			// Gallery
			/* TweenMax.staggerFrom(this.$el.querySelectorAll(''), 2, {
				x: '30%',
				opacity: 0,
				ease: Power2.easeOut
			}) */

			// Titles
			TweenMax.staggerFrom(this.$el.querySelectorAll('.am-post__title span'), 1.5, {
				delay: .2,
				y: '200px',
				ease: Power2.easeOut
			}, .2)
		},

		onLoad() {
			let images = this.$el.querySelectorAll('.am-post__background, .am-post__listimg')
			let imagesBlog = this.$el.querySelectorAll('.am-post__image, .am-post__image_bottom, .am-post__first')
			let allLoaded = false;

			images.forEach((image, index) => {
				let img = new Image()

				img.src = image.dataset.src
				img.onload = () => {
					image.style.backgroundImage = `url(${img.src})`

				}
			})
			imagesBlog.forEach((image, index) => {
				let img = new Image()

				img.src = image.dataset.src
				img.onload = () => {
					image.style.backgroundImage = `linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #000000 100%), url(${img.src})`

					if (index + 1 == imagesBlog.length) {
						this.loaded = true
						this.start()
					}
				}
			})
			
		}
	}
}
</script>

<style lang="scss">
@media only screen and (max-width: 990px) {
	.post-mobile-height{
		height: 250px;
	}
}

.am-post{
	background: white;
	position: relative;
	z-index: 10;
	transition: .3s $easeInOutQuad;
	
	&__img-btn-text{
		font-family: Khand;
		color: #fff;
		font-style: normal;
		font-weight: 300;
		font-size: 40px;
		line-height: 120%;
		letter-spacing: 0.01em;
		max-width: 573px;
		margin-left: 8%;
		bottom: 30px;
		position: absolute;
	}
	&__img-btn-text span{
		font-family: Khand;
		color: #99887F;
		

		font-style: normal;
		font-weight: normal;
		font-size: 15px;
		line-height: 16px;

		background: #ffffff;
		border-radius: 100px;
		padding: 5px 25px;
	}

	&__container{
		display: flex;
		flex-flow: column;
		height: 100%;
		@include outer-container;
	}
		@include grid-media($smartphone-grid) {
		&__img-btn-text{
			font-size: 26px;
		}
	}


	&__wrapper{
		flex: 1;
		@include grid-column(6);
		/* @media only screen and (max-width: 990px) {
			@include grid-column(12);
		} */

	}
	&__background{
		position: relative;
		top: 0;
		left: 0;
		width: 100%;
		height: 100px;
		opacity: 1;
		z-index: 1;
		background-size: cover;
		background-position: center;
	}
	&__background > h1{
		top: 25%;
		position: relative;

		font-family: SanFrancisco;
		font-style: normal;
		font-weight: 100;
		font-size: 70px;
		line-height: 84px;
		letter-spacing: 0.01em;
		color: #99887F;

	}
	&__header{
		margin-top: 54px;
		margin-bottom: 97px;
		padding-bottom: 24px;
		position: relative;
		z-index: 2;
		&:after{
			content: "";
			position: absolute;
			width: 100%;
			height: 1px;
			bottom: -1px;
			background: rgba($c-gray, .6);
			transition: 1s $easeInOutQuad .75s;
		}
	}
	@include grid-media($smartphone-grid) {
		&__header{
			margin-bottom: 40px;
		}
	}

	&__title{
		font-family: SanFrancisco;
		font-style: normal;
		font-weight: 100;
		font-size: 70px;
		line-height: 84px;
		letter-spacing: 0.01em;

		color: #99887F;

		overflow: hidden;
		span{
			display: block;
		}
		&--first{
			color: white;
		}
		&--second{
			color: #E3E3E3;
		}
		&--third{
		}
	}
	&__text{
		opacity: .8;
		margin-bottom: 40px;
		transition: 1s $easeOutQuad 1.5s;
	}
	&__image{
		max-height: 1259px;
		flex: 1;
		background-size: cover;
		background-position: center;
	}
	&__image_bottom{
		flex: 1;
		background-size: cover;
		background-position: center;
	}

	&.is-idle{
		opacity: 0;
		.am-post{
			&__header{
				&:after{
					width: 0%;
					opacity: 0;
					transition: .5s $easeInOutQuad;
				}
			}
			&__text{
				transform: translateY(20px);
				opacity: 0;
				transition: .5s $easeInOutQuad;
			}
		}
	}
	&__listtitle{
		position: relative;
		/* top: 403px; */
		/* right: 50%; */
		/* bottom: 0; */
		/* left: 0; */
		height: 480px;
		max-width: 489px;
		margin-left: 83px ;
		margin-right: 83px ;
		padding: 96px 0px;
		&__text{
			font-family: Khand;
			font-style: normal;
			font-weight: 300;
			font-size: 50px;
			line-height: 120%;
			letter-spacing: 0.01em;
			color: #6D594F;
		}
		&__header{
			font-family: Khand;
			font-style: normal;
			font-weight: normal;
			font-size: 25px;
			line-height: 25px;
			letter-spacing: 0.01em;
			color: #6D594F;

			width: 80px;
			border-bottom: 1px solid #6D594F;
		}
	}

	@include grid-media($tablet-grid) {
		&__wrapper{
			@include grid-column(4);
		}
		&__image{
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 50%;
			
			&:after{
				content: "";
				display: block;
				padding-top: 60%;
			}
		}

		&__listtitle{
			&__header{

				margin-top: 90px !important;
			}
		}

	}
	@include grid-media($smartphone-grid) {
		&__wrapper{
			@include grid-column(6);
		}
		&__image{
			position: relative;
			top: 0;
			right: 0;
			bottom: 0;
			/* left: 50%; */
			
			&:after{
				content: "";
				display: block;
				padding-top: 60%;
			}
		}
		&__listtitle{
			&__header{

				margin-top: 90px !important;
			}
		}

	}

	@include grid-media($desktop-grid) {
		display: block;
		&__image{
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 50%;
			
			&:after{
				content: "";
				display: block;
				padding-top: 60%;
			}
		}
		&__first{
			position: relative;
			/* top: 403px; */
			/* right: 50%; */
			/* bottom: 0; */
			/* left: 0; */
			height: 480px;
			width: 100%;
			&:after{
				content: "";
				display: block;
				padding-top: 60%;
			}
		}
		&__list__item{
			/* columns: 2; */
		}
		&__listimg{
			position: relative;
			/* top: 403px; */
			/* right: 50%; */
			/* bottom: 0; */
			/* left: 0; */
			height: 480px;
			/* width: 50%; */
			background-position: center;
			background-size: cover;
			&:after{
				content: "";
				display: block;
				padding-top: 60%;
			}
		}

		&__image_bottom{
			position: absolute;
			top: 50%;
			right: 0;
			bottom: 0;
			left: 50%;
			&:after{
				content: "";
				display: block;
				padding-top: 60%;
			}
		}
		&__background{
			margin-top: 180px;
			height: 200px;
		}
		&__header{
			margin-top: 144px;
			&:after{
				width: 280px;
			}
		}
		&__title{
			line-height: 64px;
		}
		&__wrapper{
			@include grid-column(5);
		}
	}
}
</style>
